import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "@/components/Reveal";
import { HOW_STEPS } from "@/data/content";
import { btnPrimary } from "@/lib/ui";
import { ArrowRight } from "lucide-react";

export const HowItWorks = ({ compact = false }) => (
  <section className="border-y border-white/5 bg-[#0c1319] py-24 md:py-36" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
      <SectionHead nr="04" overline="Het systeem" title="Hoe werkt thermische branddetectie?" />

      <div className="relative mt-16">
        <div className="absolute left-5 top-0 h-full w-px bg-gradient-to-b from-[#2B9FD7]/60 via-[#2B9FD7]/20 to-transparent lg:left-0 lg:top-6 lg:h-px lg:w-full lg:bg-gradient-to-r" aria-hidden="true" />
        <ol className="grid gap-10 lg:grid-cols-5 lg:gap-6">
          {HOW_STEPS.map((step, i) => (
            <Reveal key={step.nr} delay={i * 0.1}>
              <li className="relative pl-14 lg:pl-0 lg:pt-14">
                <span className="absolute left-0 top-0 flex h-11 w-11 items-center justify-center rounded-full border border-[#2B9FD7]/50 bg-[#090D10] font-heading text-sm font-bold text-[#62C3F0] shadow-[0_0_18px_rgba(43,159,215,0.35)] lg:left-0">
                  {step.nr}
                </span>
                <h3 className="font-heading text-base font-bold text-[#F5F7F9]">{step.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[#CBD3D9]/80">{step.text}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>

      {!compact && (
        <Reveal delay={0.2} className="mt-16">
          <Link to="/offerte" className={btnPrimary} data-testid="how-cta">
            Laat uw risicogebieden in kaart brengen <ArrowRight size={16} />
          </Link>
        </Reveal>
      )}
    </div>
  </section>
);
